const $$splitComponentImporter = () => import('/home/dylan/code/helldivers2-classes/packages/web/src/client/routes/owned-items.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/owned-items")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface SourceGroup {
  slug: string;
  name: string;
  bucket: Bucket;
  items: OwnedPageItem[];
}